export default class FormModule {
  constructor() {
    this.init();
  }

  init() {
    this.checkInputValues();
  }

  /**
   * Check all form inputs for values and add .has-value class to parent .gfield
   */
  checkInputValues() {
    const formWrapper = document.querySelector('.form-module__gravity-form');
    if (!formWrapper) return;

    // Get all input elements (text, email, number, etc.)
    const textInputs = formWrapper.querySelectorAll('input[type="text"], input[type="email"], input[type="number"], input[type="tel"], input[type="url"]');

    // Get all textareas
    const textareas = formWrapper.querySelectorAll('textarea');

    // Get all select elements
    const selects = formWrapper.querySelectorAll('select');

    // Get all checkboxes and radio buttons
    const checkboxes = formWrapper.querySelectorAll('input[type="checkbox"]');
    const radios = formWrapper.querySelectorAll('input[type="radio"]');

    // Helper function to find parent .gfield
    const findParentGfield = (element) => {
      return element.closest('.gfield');
    };

    // Helper function to check and update has-value class
    const updateHasValueClass = (input) => {
      const gfield = findParentGfield(input);
      if (!gfield) return;

      if (input.value && input.value.trim() !== '') {
        gfield.classList.add('has-value');
      } else {
        gfield.classList.remove('has-value');
      }
    };

    // Helper function for select elements (check if not placeholder)
    const updateSelectHasValueClass = (select) => {
      const gfield = findParentGfield(select);
      if (!gfield) return;

      const selectedOption = select.options[select.selectedIndex];
      const isPlaceholder = selectedOption && selectedOption.classList.contains('gf_placeholder');

      if (select.value && select.value.trim() !== '' && !isPlaceholder) {
        gfield.classList.add('has-value');
      } else {
        gfield.classList.remove('has-value');
      }
    };

    // Helper function for checkboxes/radios (check if any in the group is checked)
    const updateCheckboxRadioHasValueClass = (input) => {
      const gfield = findParentGfield(input);
      if (!gfield) return;

      // For checkboxes and radios, check if any input in the gfield is checked
      const allInputsInField = gfield.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      const hasChecked = Array.from(allInputsInField).some(inp => inp.checked);

      if (hasChecked) {
        gfield.classList.add('has-value');
      } else {
        gfield.classList.remove('has-value');
      }
    };

    // Process text inputs and textareas
    [...textInputs, ...textareas].forEach(input => {
      // Check initial value
      updateHasValueClass(input);

      // Add event listeners for dynamic updates
      input.addEventListener('input', () => updateHasValueClass(input));
      input.addEventListener('change', () => updateHasValueClass(input));
    });

    // Process select elements
    selects.forEach(select => {
      // Check initial value
      updateSelectHasValueClass(select);

      // Add event listener for changes
      select.addEventListener('change', () => updateSelectHasValueClass(select));
    });

    // SelectC8 (see 5-libs/SelectC8.js) sets the real <select>'s value via
    // jQuery's `.val(val).change()` when an option is picked, not through a
    // genuine user interaction — that doesn't reliably reach the vanilla
    // 'change' listener above through addEventListener in every case.
    // jQuery's own event system is guaranteed to notify a jQuery-registered
    // handler for a jQuery-triggered event, so this is the reliable path for
    // catching a SelectC8 selection.
    if (window.jQuery) {
      window.jQuery(formWrapper).on('change', 'select', (e) => updateSelectHasValueClass(e.target));
    }

    // // Process checkboxes
    // checkboxes.forEach(checkbox => {
    //   // Check initial state
    //   updateCheckboxRadioHasValueClass(checkbox);

    //   // Add event listener for changes
    //   checkbox.addEventListener('change', () => updateCheckboxRadioHasValueClass(checkbox));
    // });

    // // Process radio buttons
    // radios.forEach(radio => {
    //   // Check initial state
    //   updateCheckboxRadioHasValueClass(radio);

    //   // Add event listener for changes
    //   radio.addEventListener('change', () => updateCheckboxRadioHasValueClass(radio));
    // });
  }
}

new FormModule();